import type {AnyObject} from './Common'

export enum FetchResponseType {
  SUCCESS = 'success',
  ERROR = 'error'
}

export interface FetchResponseError {
  errors?: {
    message: string
    path: string[]
    extensions?: {
      validation?: Record<string, string[]>
    }
  }[]
}

export interface FetchResponse<TData> {
  type: FetchResponseType
  message: string
  data: TData | null
  validationErrors?: Record<string, string[]>
}

export type FetchRequestAttrs = {
  [key: string | number]:
    | boolean
    | number
    | string
    | string[]
    | { name: string, value: boolean | number | string | string[] }[]
}
| AnyObject
